import { render } from "./SelectCustom.vue?vue&type=template&id=000c8d56&scoped=true&ts=true"
import script from "./SelectCustom.vue?vue&type=script&lang=ts"
export * from "./SelectCustom.vue?vue&type=script&lang=ts"

import "./SelectCustom.vue?vue&type=style&index=0&id=000c8d56&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000c8d56"]])

export default __exports__